export { KUBERNETES_V1_MODULE } from './kubernetes.v1.module';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v1/index.ts